export enum VersandwegEnum {
  EMAIL = "EMAIL",
  POST = "POST",
}
